import { Button, Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import { dashboardMenu, onGoingDonations, stats } from "../../../data";
import DonationList from "../DonationList";
import Statsbox from "./Statsbox";
import { useDispatch, useSelector } from "react-redux";
import UpComingCollections from "../UpComingCollections";
import {
  CollectionStatus,
  ComponentType,
  EntityType,
} from "../../../common/enum";
import Box from "@mui/material/Box";

import Avatar from "@mui/material/Avatar";

import SectionHeading from "../SectionHeading";
import { setDashboardTab, setSelectedDonation,getMyActiveDonation } from "../slice";
import SvgIconStyle from "../../../components/SvgIconStyle";
import { getMyHistoryCollection } from "../../CreateCollection/slice";
import CollectionList from "../CollectionList";
import { useCollection } from "../Actions/ActionDate/useCollection";
import { useNavigate } from "react-router-dom";


const mainBoxStyles = { display: "flex", justifyContent: "space-between" };

const avataStyles = { bgcolor: "#E4F2E8", width: "58px", height: "58px" };

const svgIconStyle = { color: "black", width: "40px", height: "40px" };

const Stats = ({ t, donations }) => {
  const { setDateState } = useCollection();
  const navigate = useNavigate();
  const {
    donationCart: { products = [], donationId, donationType, productList } = {},
    collection: { loading, historyCollection },
    dashboardInfo: { myActiveDonations, entityProfileSelect },
    auth: {
      profile: { entity, userId },
    },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  // const [donations, setDonations] = React.useState(null);

//     React.useEffect(() => {
//   if (!entity?.entityId) return;

//   dispatch(getMyActiveDonation({
//     entityId: entity.entityId,
//     entityType: 'DONOR'
//   }))
//     .unwrap()
//     .then((res) => {
//       setDonations(res?.donationDetails || []);
//     });

// }, [entity?.entityId]);

  React.useEffect(() => {
    let payload = {
      offset: 0,
      limit: 10,
      status: CollectionStatus.collected,
    };
    if (
      entity?.entityType === EntityType.distributor ||
      entity?.entityType === EntityType.donorDistributor ||
      entity?.entityType === EntityType.specialDistributor
    ) {
      payload["collectorId"] = entity?.entityId;
      dispatch(getMyHistoryCollection(payload));
    }
  }, [entity, dispatch]);



  return (
    <>
      {(entity?.entityType === EntityType.donor ||
        entity?.entityType === EntityType.donorDistributor) && (
        <>
          <Typography
            variant="h1"
            style={{
              marginBottom: "5px",
              fontSize: "24px",
              fontFamily: "Sitka Heading",
            }}
          >
            {t("myActivitySummary")}
          </Typography>
          <Typography
            variant="h2"
            style={{
              marginBottom: "15px",
              fontSize: "small",
              fontFamily: "Poppins",
              fontWeight: 600,
              color: "#6E6E6E",
            }}
          >
            {t("myActivitySummarySub")}
          </Typography>

          <Paper sx={{ padding: "10px" }}>
            <Typography fontSize={"16"} fontWeight={"medium"} sx={{}}>
              {t("simpleStatThisMonth")}{" "}
            </Typography>
            <Divider />
            <Grid container>
             {stats?.map((item, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Statsbox item={item} t={t} myDonationss={donations}/>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </>
      )}
      {(entity?.entityType === EntityType.distributor ||
        entity?.entityType === EntityType.donorDistributor ||
        entity?.entityType === EntityType.specialDistributor) && (
        <Grid
          item
          sx={{
            marginTop:
              entity?.entityType === EntityType.donorDistributor ? "40px" : 0,
          }}
        >
          <UpComingCollections t={t} />
        </Grid>
      )}
      {(entity?.entityType === EntityType.donor ||
        (entity?.entityType === EntityType.donorDistributor &&
          entityProfileSelect === EntityType.donor)) && (
        <Grid item sx={{ marginTop: "40px" }}>
          <Typography
            variant="h1"
            style={{
              fontSize: "24px",
              fontWeight: 600,
              fontFamily: "Sitka Heading"
            }}
            sx={{
              paddingX: {
                xs: "17px",
                sm: "17px",
                md: "17px",
                lg: "0px",
                xl: "0px",
              },
            }}
          >
            {entity?.entityType === EntityType.donor ||
            entityProfileSelect === EntityType.donor
              ? t("myOngoingDonations")
              : t("ongoingDonations")}{" "}
            <Button
              variant="contained"
              disableRipple={true}
              sx={{
                fontFamily: "Poppins",
                color: "#37773E",
                background: "#E1EFB0",
                "&:hover": {
                  color: "white",
                },
                float: {
                  xs: "right",
                  sm: "right",
                  md: "right",
                  lg: "none",
                  xl: "none",
                },
                borderRadius:"4px"
              }}
              onClick={() => {
                // dispatch(setSelectedDonation(myActiveDonations[0]));
                // dispatch(setDashboardTab(dashboardMenu[1].title));
                navigate(dashboardMenu[1].link);
              }}
            >
              {t("seeAll")}
            </Button>
          </Typography>
          <Typography
            fontSize={"small"}
            fontFamily={"Poppins"}
            sx={{
              color: "#6E6E6E",
              paddingLeft: {
                xs: "17px",
                sm: "17px",
                md: "17px",
                lg: "0px",
                xl: "0px",
              },
            }}
          >
            {t("subHeadingDonationDashboard")}
          </Typography>
          <Stack
            spacing={1}
            sx={{
              p: 1,
              height: "350px",
              overflow: "hidden",
              // overflowY: "scroll",
              width: 1,
            }}
          >
            {myActiveDonations?.length > 0 &&
              myActiveDonations?.map((listItem, index) => (
                <DonationList
                  t={t}
                  item={listItem}
                  key={index}
                  component={ComponentType.DASHBOARD_STATS}
                />
              ))}
            {myActiveDonations.length === 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  mt: "5%",
                }}
              >
                <Avatar sx={avataStyles}>
                  <SvgIconStyle
                    src="/static/dashboard/box.svg"
                    sx={svgIconStyle}
                  />
                </Avatar>
                <Box sx={{ paddingLeft: "10px" }}>
                  <Typography sx={{ marginTop: "10px" }}>
                    Ainda não tem doações. Clique em Nova doação para começar
                  </Typography>
                </Box>
              </Box>
            )}
          </Stack>
        </Grid>
      )}
      {(entity?.entityType === EntityType.distributor ||
        entity?.entityType === EntityType.specialDistributor ||
        (entity?.entityType === EntityType.donorDistributor &&
          entityProfileSelect === EntityType.distributor)) && (
        <Grid item sx={{ marginTop: "40px" }}>
          <Typography
            fontSize={"24px"}
            fontWeight={600}
            fontFamily={"Sitka Heading"}
            sx={{
              paddingX: {
                xs: "17px",
                sm: "17px",
                md: "17px",
                lg: "0px",
                xl: "0px",
              },
            }}
          >
            {t("collectionHistory")}{" "}
            <Button
              variant="contained"
              disableRipple={true}
              sx={{
                fontFamily: "Poppins",
                color: "#37773E",
                background: "#E1EFB0",
                "&:hover": {
                  color: "white",
                },
                float: {
                  xs: "right",
                  sm: "right",
                  md: "right",
                  lg: "none",
                  xl: "none",
                },
                borderRadius:"4px"
              }}
              onClick={() => {
                // dispatch(setDashboardTab(dashboardMenu[2].title));
                navigate(dashboardMenu[2].link);
              }}
            >
              {t("seeAll")}
            </Button>
          </Typography>
          <Typography
            fontSize={"small"}
            fontFamily={"Poppins"}
            sx={{
              color: "#6E6E6E",
              paddingLeft: {
                xs: "17px",
                sm: "17px",
                md: "17px",
                lg: "0px",
                xl: "0px",
              },
            }}
          >
            {t("toMyrecentCollection")}
          </Typography>
          <Stack
            spacing={1}
            sx={{
              p: 1,
              height: "310px",
              overflow: "hidden",
              // overflowY: "scroll",
              width: 1,
            }}
          >
            {Object.keys(historyCollection)?.length > 0 &&
              historyCollection?.collectionDetails?.length > 0 &&
              historyCollection?.collectionDetails.map((item) => (
                <CollectionList
                  item={item}
                  t={t}
                  key={item.collection.id}
                  setDateValue={setDateState}
                />
              ))}
            {Object.keys(historyCollection).length > 0 &&
              historyCollection?.collectionDetails.length === 0 && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    mt: "5%",
                  }}
                >
                  <Avatar sx={avataStyles}>
                    <SvgIconStyle
                      src="/static/dashboard/icon-collectionhistory.svg"
                      sx={svgIconStyle}
                    />
                  </Avatar>
                  <Box sx={{ paddingLeft: "10px" }}>
                    <Typography sx={{ marginTop: "10px" }}>
                      {t("noCollectionHistory")}
                    </Typography>
                  </Box>
                </Box>
              )}
          </Stack>
        </Grid>
      )}
    </>
  );
};

export default Stats;
